import { QueryFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { BorrowerpairItems } from '../borrowerpair/types';

export interface GetFieldsParams {
  loanId: string;
  cursor?: string;
}

export interface DataPanelResponse {
  success: boolean;
  data: BorrowerpairItems[];
}

export const fetchExternalFieldsByLoan = async (
  params: GetFieldsParams,
): Promise<BorrowerpairItems[]> => {
  // Validate loanId before making HTTP request
  if (!params.loanId || params.loanId.trim() === '') {
    throw new Error('Invalid loanId: loanId is required and cannot be empty');
  }

  const queryParams = new URLSearchParams();

  if (params.cursor) {
    queryParams.append('cursor', params.cursor);
    queryParams.append('limit', '100');
  }

  let url = `/loans/${params.loanId}/data`;
  if (queryParams.size > 0) {
    url += `?${queryParams.toString()}`;
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<DataPanelResponse>(url);

  if (response.data?.data?.length) {
    return response.data.data;
  }

  throw new Error('Failed to fetch data panel fields');
};

const getExtratedFieldsByLoan: QueryFunction<
  BorrowerpairItems[],
  ['/loan-external-fields', GetFieldsParams]
> = async ({ queryKey }) => fetchExternalFieldsByLoan(queryKey[1]);

export default getExtratedFieldsByLoan;
